import * as React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { AUTH_TEXT_SECONDARY, BRAND_BLUE } from "../theme/appTheme";
import { useTranslation } from "../i18n/LanguageContext";

const labelSx = { fontSize: "0.78125rem", color: AUTH_TEXT_SECONDARY, lineHeight: 1.4 };

// Round, MUI-Checkbox-free "checkbox" — a plain circle that fills with the
// brand color when checked, per the requested circular-checkbox style.
function CircleIcon({ checked }) {
  return (
    <Box
      sx={{
        width: 18,
        height: 18,
        borderRadius: "50%",
        flexShrink: 0,
        border: `2px solid ${checked ? BRAND_BLUE : "#d1d5db"}`,
        bgcolor: checked ? BRAND_BLUE : "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.12s, border-color 0.12s",
      }}
    >
      {checked && (
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            bgcolor: "#ffffff",
          }}
        />
      )}
    </Box>
  );
}

const checkboxSx = { p: 0, mr: 1 };

// The two optional consent toggles from /profile/me - reused at registration
// time and later in Account Settings so they always stay in sync visually.
// Rendered one per row (not side by side) with a round custom checkbox.
function ConsentCheckboxes({ consentPortalUpdates, consentMarketing, onChange, sx }) {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75, ...sx }}>
      <FormControlLabel
        sx={{ alignItems: "flex-start", ml: 0, mr: 0, width: "100%" }}
        control={
          <Checkbox
            checked={Boolean(consentPortalUpdates)}
            onChange={(e) => onChange({ consentPortalUpdates: e.target.checked, consentMarketing })}
            icon={<CircleIcon checked={false} />}
            checkedIcon={<CircleIcon checked />}
            disableRipple
            sx={checkboxSx}
          />
        }
        label={
          <Typography sx={{ ...labelSx, mt: "1px" }}>
            {t("auth.consent.portalUpdates")}
          </Typography>
        }
      />
      <FormControlLabel
        sx={{ alignItems: "flex-start", ml: 0, mr: 0, width: "100%" }}
        control={
          <Checkbox
            checked={Boolean(consentMarketing)}
            onChange={(e) => onChange({ consentPortalUpdates, consentMarketing: e.target.checked })}
            icon={<CircleIcon checked={false} />}
            checkedIcon={<CircleIcon checked />}
            disableRipple
            sx={checkboxSx}
          />
        }
        label={<Typography sx={{ ...labelSx, mt: "1px" }}>{t("auth.consent.marketing")}</Typography>}
      />
    </Box>
  );
}

export default ConsentCheckboxes;
